import * as z from "zod";

const AppleMessagesBusinessLinkSchema_ = z.object({
  businessId: z.string(),
  name: z.string().nullable(),
  logoUrl: z.string().nullable(),
  linkedAt: z.string(),
});
export const AppleMessagesBusinessLinkSchema: z.ZodType<AppleMessagesBusinessLink> =
  AppleMessagesBusinessLinkSchema_;
export interface AppleMessagesBusinessLink extends z.infer<
  typeof AppleMessagesBusinessLinkSchema_
> {}

/** Apple's Business IDs are UUIDs; anything else is a mangled landing-page URL. */
export const appleMessagesBusinessIdSchema = z.string().uuid();
